import axios from 'axios'

axios.defaults.withCredentials = true
const REACT_APP_BACKEND_URL = process.env.REACT_APP_API_URL

// const REACT_APP_BACKEND_URL = 'https://app.semestera.com'

/* eslint-disable no-plusplus */
/* eslint-disable prefer-template */
function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export const user = async (data) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie('csrftoken'),
        }
    };
    // const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/tophighlights`);
    const response = await axios.get(`${REACT_APP_BACKEND_URL}/v1/user`, config);
    return response.data
};

export const signup = async (data) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie('csrftoken'),
        }
    };
    // const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/tophighlights`);
    const response = await axios.post(`${REACT_APP_BACKEND_URL}/v1/signup`, data, config);
    return response.data
};

export const login = async (data) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie('csrftoken'),
        }
    };
    // const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/tophighlights`);
    const response = await axios.post(`${REACT_APP_BACKEND_URL}/v1/login`, data,config);
    return response.data
};

export const logout = async (data) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie('csrftoken'),
        }
    };
    // const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/tophighlights`);
    const response = await axios.post(`${REACT_APP_BACKEND_URL}/v1/logout`, data, config);
    return response.data
};


